export enum AccountKind {
    REWARDS_SENDING = "REWARDS_SENDING",
    REWARDS_RECEIVING = "REWARDS_RECEIVING",
}
